import i18n from '@/i18n';
import axios from 'axios';
import store from '@/store';

store.commit('UpdateLang', i18n.global.locale);

const loadedLanguages = ['en-US'];

function setI18nLanguage(lang: string): string {
    i18n.global.locale = lang as any;
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html')?.setAttribute('lang', lang);
    return lang;
}

export async function loadLanguageAsync(lang: string): Promise<string> {
    // If the same language
    if (i18n.global.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang));
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        const result = Promise.resolve(setI18nLanguage(lang));
        store.commit('UpdateLang', lang);
        return result;
    }

    // If the language hasn't been loaded yet
    return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.json`).then((messages) => {
        i18n.global.setLocaleMessage(lang, messages);
        loadedLanguages.push(lang);
        const result = Promise.resolve(setI18nLanguage(lang));
        store.commit('UpdateLang', lang);
        return result;
    });
}
